import { render, staticRenderFns } from "./ShowDialog.vue?vue&type=template&id=a9bb1b38&scoped=true"
import script from "./ShowDialog.vue?vue&type=script&lang=js"
export * from "./ShowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb1b38",
  null
  
)

export default component.exports